export const MAGACIN_URLS = {
  businessPortal: 'https://business.magacin.mk',
} as const
